<template>
  <header class="bg-white border-b border-gray-200 sticky top-0 z-50">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <!-- Logo -->
        <RouterLink to="/" class="flex items-center">
          <img
            src="/greyed-logo.png"
            alt="GreyED - EdTech Clarified"
            class="h-10 w-auto"
          />
        </RouterLink>

        <!-- Navigation -->
        <nav class="hidden md:flex space-x-8">
          <RouterLink
            to="/about"
            class="text-gray-600 hover:text-red-900 transition-colors"
            active-class="text-red-900 font-semibold"
          >
            About
          </RouterLink>
          <RouterLink
            v-if="showContactLink"
            to="/contact"
            class="text-gray-600 hover:text-red-900 transition-colors"
            active-class="text-red-900 font-semibold"
          >
            Contact
          </RouterLink>
          <RouterLink
            to="/honors-and-awards"
            class="text-gray-600 hover:text-red-900 transition-colors"
            active-class="text-red-900 font-semibold"
          >
            Honors and Awards
          </RouterLink>
          <RouterLink
            to="/services"
            class="text-gray-600 hover:text-red-900 transition-colors"
            active-class="text-red-900 font-semibold"
          >
            Services
          </RouterLink>
          <RouterLink
            v-if="showTestimonialsLink"
            to="/testimonies"
            class="text-gray-600 hover:text-red-900 transition-colors"
            active-class="text-red-900 font-semibold"
          >
            Testimonies
          </RouterLink>
          <RouterLink
            to="/why-work-with-us"
            class="text-gray-600 hover:text-red-900 transition-colors"
            active-class="text-red-900 font-semibold"
          >
            Why Work With Us
          </RouterLink>
        </nav>

        <!-- CTA Button -->
        <Button class="bg-red-900 hover:bg-red-800 text-white">
          Get Started
        </Button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import Button from "@/components/ui/Button.vue";
import { useFeatureFlag } from "@/lib/featureFlags";

const showContactLink = useFeatureFlag("contactForm");
const showTestimonialsLink = useFeatureFlag("testimonials");
</script>
